import axios from 'axios'
import https from 'https'
import { hostname } from '@/utils/hostname'
import router from '../router'



const tokenErros = [
  'token expired',
  'token invalid',
  'token not found'
]

var redirect = true;
const errorTokenFunc = error => {
  if (error.response.status === 401 && tokenErros.includes(error.response.data.status)) {
    if(redirect){
      window.alert('Seu login expirou.')
      localStorage.removeItem('pcm_access_token')
      localStorage.removeItem('pcm_permissions')   
      router.push({ name: 'login' })
      redirect = false
      throw error
    }
    throw error
   
  } else {
    throw error
  }
}
const responseOk = response =>{
  redirect = true
  return response
}


const httpsAgent = new https.Agent({
  rejectUnauthorized: false,
})
export function apiClientGeral() {
  const axiosconfig = axios.create({
    httpsAgent,
    baseURL: `https://${hostname()}/backend/asterisk`,
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('pcm_access_token')}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
  axiosconfig.interceptors.response.use(
    responseOk,
    errorTokenFunc 
   
  )

  return axiosconfig
}

export function apiClientAudio() {
  const axiosconfig = axios.create({
    httpsAgent,
    baseURL: `https://${hostname()}/backend/asterisk`,
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('pcm_access_token')}`,
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data',
    },
  })
  axiosconfig.interceptors.response.use(
    responseOk,
    errorTokenFunc
  )

  return axiosconfig
}

export function apiDownloadAudio() {
  return axios.create({
    baseURL: `https://${hostname()}/backend/asterisk`,
    responseType: 'blob',
  })
}

export function apiClient() {
  return axios.create({
    baseURL: `https://${hostname()}/backend/auth`,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
}

export function apiRegistro() {
  const axiosconfig = axios.create({
    httpsAgent,
    baseURL: `https://${hostname()}/backend/auth`,
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('pcm_access_token')}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
  axiosconfig.interceptors.response.use(
    responseOk,
    errorTokenFunc
  )

  return axiosconfig
}

export function apiCallCenter() {
  const axiosconfig = axios.create({
    httpsAgent,
    baseURL: `https://${hostname()}/backend/callcenter`,
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('pcm_access_token')}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
  axiosconfig.interceptors.response.use(
    response => response,
    errorTokenFunc
  )

  return axiosconfig
}

export function apiPesquisaSatisfacao() {
  const axiosconfig = axios.create({
    httpsAgent,
    baseURL: `https://${hostname()}/backend`,
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('pcm_access_token')}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
  axiosconfig.interceptors.response.use(
    responseOk,
    errorTokenFunc
  )

  return axiosconfig
}

export function apiPainelAdministrativo() {
  let axiosconfig = axios.create({
    httpsAgent,
    baseURL: `https://${hostname()}/backend/comercial`,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
  axiosconfig.interceptors.request.use(config => {
    config.headers = {
      Authorization: `Bearer ${window.localStorage.getItem('pcm_access_token')}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    }

    return config
  })
  return axiosconfig
}

export function apiCallCenterOperador() {
  const axiosconfig = axios.create({
    httpsAgent,
    baseURL: `https://${hostname()}/backend/callcenter`,
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('pcm_access_token_operador')}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
  axiosconfig.interceptors.response.use(
    responseOk,
    errorTokenFunc
    
  )

  return axiosconfig
}

export function apiClientName() {
  const token = window.localStorage.getItem('pcm_access_token_operador')
    ? window.localStorage.getItem('pcm_access_token_operador')
    : window.localStorage.getItem('pcm_access_token')

  const axiosconfig = axios.create({
    httpsAgent,
    baseURL: `https://${hostname()}/backend/config`,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  })

  axiosconfig.interceptors.response.use(
    responseOk,
    errorTokenFunc
  )

  return axiosconfig
}

export function apiAgi() {
  const axiosconfig = axios.create({
    httpsAgent,
    baseURL: `https://${hostname()}/backend/agi`,
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('pcm_access_token')}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
  axiosconfig.interceptors.response.use(
    responseOk,
    errorTokenFunc
  )

  return axiosconfig
}

export function apiAgiOperador() {
  const axiosconfig = axios.create({
    httpsAgent,
    baseURL: `https://${hostname()}/backend/agi`,
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('pcm_access_token_operador')}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
  axiosconfig.interceptors.response.use(
    responseOk,
    errorTokenFunc
  )

  return axiosconfig
}

export function apiClientRelatoriosCallCenter() {
  const axiosconfig = axios.create({
    httpsAgent,
    baseURL: `https://${hostname()}/backend/callcenter/relatorios`,
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('pcm_access_token')}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
  axiosconfig.interceptors.response.use(
    responseOk,
    errorTokenFunc
  )

  return axiosconfig
}


export function apiClientGeralOperador() {
  const axiosconfig = axios.create({
    httpsAgent,
    baseURL: `https://${hostname()}/backend/asterisk`,
    headers: {
      Authorization: `Bearer ${window.localStorage.getItem('pcm_access_token_operador')}`,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  })
  axiosconfig.interceptors.response.use(
    responseOk,
    errorTokenFunc 
   
  )

  return axiosconfig
}
